import { useCallback, useSyncExternalStore } from "react";

const MOBILE_UI_V1_MEDIA_QUERY = "(min-width: 360px) and (max-width: 639px)";
const MOBILE_UI_V1_BELOW_MINIMUM_QUERY = "(max-width: 359px)";
type MobileUiV1Presenter = "below-minimum" | "mobile" | "desktop";

export function useMediaQuery(query: string, fallback = false): boolean {
  const getSnapshot = useCallback(() => {
    if (typeof window === "undefined" || !window.matchMedia) return fallback;
    return window.matchMedia(query).matches;
  }, [fallback, query]);

  const getServerSnapshot = useCallback(() => fallback, [fallback]);

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      if (typeof window === "undefined" || !window.matchMedia) {
        return () => undefined;
      }

      const mediaQuery = window.matchMedia(query);
      const onChange = () => onStoreChange();
      mediaQuery.addEventListener("change", onChange);
      return () => mediaQuery.removeEventListener("change", onChange);
    },
    [query]
  );

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export interface MobileUiV1State {
  isMobileViewport: boolean;
  isBelowMinimumWidth: boolean;
  presenter: MobileUiV1Presenter;
}

export function useMobileUiV1State(): MobileUiV1State {
  const isMobileViewport = useMediaQuery(MOBILE_UI_V1_MEDIA_QUERY);
  const isBelowMinimumWidth = useMediaQuery(MOBILE_UI_V1_BELOW_MINIMUM_QUERY);

  return {
    isMobileViewport,
    isBelowMinimumWidth,
    presenter: isBelowMinimumWidth
      ? "below-minimum"
      : isMobileViewport
        ? "mobile"
        : "desktop",
  };
}
